import type { SectionAssignment } from '@breakoutlearning/firebase-repository/models/SectionAssignment'
import { BreakoutSelect } from 'components/design-system/BreakoutSelect'
import { useTranslationTyped } from 'i18n/i18n'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

export const GradingLineItemSelect = observer(function GradingLineItemSelect({
  assignment,
  onChange,
}: {
  assignment: SectionAssignment
  onChange?: (ltiGradingLineItemId: string) => void
}) {
  const { tt } = useTranslationTyped()

  const options =
    assignment.data.ltiGradingLineItemOptions?.map((option) => ({
      label: tt.lti.configuration.brightspace_grade_item_label_with_score({
        label: option.label,
        scoreMaximum: option.scoreMaximum,
      }),
      value: option.id,
    })) ?? []

  const [lineItem, setLineItem] = useState<string>(
    assignment.data.ltiGradingLineItemId || ''
  )

  return (
    <BreakoutSelect
      value={lineItem}
      options={options}
      onChange={(ltiGradingLineItemId) => {
        setLineItem(ltiGradingLineItemId)
        onChange?.(ltiGradingLineItemId)
      }}
    />
  )
})
